module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/like-active-a98094d0c449c7fa7190737a9450d7e4.svg";